import { useIntl } from 'react-intl';
import { usePathParam } from 'react-resource-router';

import { LinkButton } from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import Link from '@atlaskit/link';

import { messages } from './premium.i18n';
import PremiumFeatureGraphic from './premium.svg';
import { PremiumProps } from './types';
import urls from './urls';

export const PremiumFeatureUpsell = ({
  featureTitle,
  featureDescription,
}: PremiumProps): JSX.Element | null => {
  const intl = useIntl();
  const [repositoryOwner] = usePathParam('repositoryOwner');
  const [workspace] = usePathParam('workspaceSlug');
  if (!workspace && !repositoryOwner) return null;

  const primaryAction = (
    <Link href={urls.learnMoreAboutPremium} target="_blank">
      {intl.formatMessage(messages.learnMoreAboutPremiumLinkLabel)}
    </Link>
  );

  const secondaryAction = (
    <LinkButton
      appearance="primary"
      href={urls.upgrade(workspace || (repositoryOwner as string))}
      target="_blank"
    >
      {intl.formatMessage(messages.upgradeLinkLabel)}
    </LinkButton>
  );

  return (
    <EmptyState
      header={featureTitle}
      description={featureDescription}
      imageUrl={PremiumFeatureGraphic}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
    />
  );
};
